import React from "react";

export default function Newabout(props) {

let myStyle={
  color:props.mode==='dark'?'white':'#042743',
  backgroundColor:props.mode==='dark'?'#042743':'white',
  // border: '0.5px solid white',
  borderColor:props.mode==='dark'?'white':'#042743',
}




  // const [myStyle, setMyStyle] = useState({
  //   color: "black",
  //   backgroundColor: "white",
  // });
  // const [buttonText, setbuttonText] = useState("Enable Dark Mode");

  // This is for manual enable dark mood 
  // const toggleStyle = () => {
  //   if (myStyle.color === "black") {
  //     setMyStyle({
  //       color: "white",
  //       backgroundColor: "#042743",
  //       border: "0.2px solid white",
  //     });
  //     setbuttonText("Enable Light Mode");
  //   } else {
  //     setMyStyle({
  //       color: "black",
  //       backgroundColor: "white",
  //     });
  //     setbuttonText("Enable Dark Mode");
  //   }
  // };

  return (
    <div className="container my-2" style={myStyle}>
      <h1>About Us</h1>
      <div
        className="accordion accordion-flush"
        id="accordionFlushExample"
        style={myStyle}
      >
        <div className="accordion-item" style={myStyle}>
          <h2 className="accordion-header" id="flush-headingOne">
            <button
              className="accordion-button collapsed"
              style={myStyle}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
            <strong>Features</strong>   
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <li>
                TextMate is a tool to analyze your text very quickly and efficiently.
              </li>
              <li>
                This a free character & word counting tool. This is very much usefull when you have to write any text under some certain word limit.
              </li>
              <li>
                One can change the cases of text, copy and delete the whole text by clickling one button.
              </li>
              <li>There is a read button which helps you read the text whatever you have written in textarea.</li>
              <li>In new update we add the preview feature of the text. Also you can get a certain idea of how much time can be taken to read the complete text if someone read it optimally.</li>
            </div>
          </div>
        </div>
        <div className="accordion-item" style={myStyle}>
          <h2 className="accordion-header" id="flush-headingTwo">
            <button
              className="accordion-button collapsed"
              style={myStyle}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo"
            >
              <strong>Developers</strong>
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTwo"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <h1>Our Developer</h1>
              <p>Srijan Kundu Chowdhury</p>
              <p>Programmer & Web Developer</p>
              <p>BE Pre-Final Year Student, Jadavpur University</p>
            </div>
          </div>
        </div>
        
        {/* <button
          onClick={toggleStyle}
          type="button"
          className="btn btn-primary my-3"
        >
          {buttonText}
        </button> */}
      </div>
    </div>
  );
}
